import { defineFcm } from '../shared/factory';

export const FCM_APPLE_PAY_ENABLED = defineFcm('apple_pay_enabled').asBoolean().withDefault(false).toConfig();
